"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _createApi = require("../createApi");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(spec, types) {
  return function (request) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, _createApi.symbol, true), _defineProperty(_ref, "types", types), _defineProperty(_ref, "requestData", _extends({}, (0, _ramda.pick)(["url", "method", "headers", "query"], spec), {
      payload: (0, _ramda.pick)(["body", "params", "custom"], request || {})
    })), _defineProperty(_ref, "map", spec.map), _ref;
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/helpers/createAction.js
// module id = 1219
// module chunks = 0